"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function lowlight(opts) {
    var inputs = tokenize(opts.input).map(function (v) { return v.toLowerCase(); });
    var words = tokenize(opts.output);
    return words.map(function (word, idx) {
        var lword = word.toLowerCase();
        var matched = inputs.find(function (input) { return lword.includes(input); });
        if (matched) {
            var em = emphasize(matched, word);
            return opts.emphasize(idx, em);
        }
        return opts.noop(idx, { word: word });
    });
}
exports.default = lowlight;
function emphasize(matched, word) {
    var start = word.toLowerCase().indexOf(matched);
    var offset = start + matched.length;
    var pre = word.slice(0, start);
    var low = word.slice(start, offset);
    var post = word.slice(offset, word.length);
    return { pre: pre, post: post, word: low };
}
function tokenize(text) {
    return text.split(' ')
        .filter(function (v) { return v !== ''; })
        .map(function (v) { return v.trim(); });
}
//# sourceMappingURL=lowlight.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/lowlight.js
// module id = bjWn
// module chunks = 20 21